import { logEvent } from "firebase/analytics";
import { analytics } from "../Context/firebaseConfig";

export const trackEvent = (eventName, params = {}) => {
  // The public site loads GA4 directly in public/index.html. Send funnel events
  // there first so they appear in the Kre8 GA4 property, even when Firebase is
  // configured with a different Analytics measurement ID.
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
  } catch { /* Analytics must never interrupt signup or the product. */ }

  if (!analytics) return;

  try {
    logEvent(analytics, eventName, params);
  } catch { /* Analytics must never interrupt signup or the product. */ }
};
